import React, { useState } from "react";
import { useEffect } from "react";
import { UserRoles } from "../shared/constants/enums";
import ProtectedRoute from "./ProtectedRoute";

import { PublicClientApplication } from "@azure/msal-browser";
import {
  msalStaffConfig,
  msalStudentConfig,
} from "../layout/login/auth/authConfig";
import { MsalProvider } from "@azure/msal-react";
import { AuthFunctions } from "../shared/utils/AuthFunctions";

function AuthenticatedProtectedRoute({
  MSALInstance,
  currentUserRole,
  authorizedRole,
  children,
}: {
  MSALInstance: PublicClientApplication;
  currentUserRole: UserRoles;
  authorizedRole: UserRoles;
  children: any;
}) {
  return (
    <React.Fragment>
      <MsalProvider instance={MSALInstance}>
        <ProtectedRoute role={authorizedRole}>{children}</ProtectedRoute>
      </MsalProvider>
    </React.Fragment>
  );
}

export default AuthenticatedProtectedRoute;
